import { forwardRef } from "react";
import MaskedInput from "react-text-mask";

const checkHours = (value: string) => {
  if (value?.length && value[0] === "0") {
    return [/[0-1]/, /\d/, ":", /[0-5]/, /\d/, " ", /[ap]/, /m/];
  } else if (value?.length && value[0] === "1") {
    return [/[0-1]/, /[0-2]/, ":", /[0-5]/, /\d/, " ", /[ap]/, /m/];
  } else if (
    value?.length &&
    ["2", "3", "4", "5", "6", "7", "8", "9"].includes(value[0])
  ) {
    return [/[2-9]/, ":", /[0-5]/, /\d/, " ", /[ap]/, /m/];
  } else {
    return [/\d/, /\d/, ":", /[0-5]/, /\d/, " ", /[ap]/, /m/];
  }
};

const TimeInput = forwardRef((props: any, _ref) => {
  return (
    <MaskedInput
      {...props}
      autoComplete="false"
      mask={(value) => checkHours(value)}
      placeholderChar="_"
      guide={true}
      keepCharPositions={true}
    />
  );
});

export default TimeInput;
